import Config from '~/constants/Config';
import { logError } from '~/logger';
import { PaymentsStoreMessage } from '../messages';
import mutationClaimKongPurchases from '~/graphql/payments/mutationClaimKongPurchases';
import mutationProcessYandexPurchase from '~/graphql/payments/mutationProcessYandexPurchase';
import { CurrencyDispatcher } from '~/flux/dispatchers';

export default async function onPlayerLoggedIn(
  {
    setPlayerId,
    emit,
  }: {
    setPlayerId: (val: string) => void;
    emit: (message: PaymentsStoreMessage, data?: unknown) => void;
  },
  action: { player: { _id: string } }
) {
  try {
    setPlayerId(action.player._id);

    if (Config.PLATFORM === 'yandex' && typeof ysdk !== 'undefined') {
      const payments = await ysdk.getPayments({ signed: true });
      const purchases = await payments.getPurchases();
      for (let i = 0; i < purchases.length; ++i) {
        setTimeout(async (purchase) => {
          try {
            const result = await mutationProcessYandexPurchase({
              playerId: action.player._id,
              purchase,
              platform: Config.PLATFORM,
            });
            if (result.currency1 != null) {
              CurrencyDispatcher.handleCurrencyAction({
                actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
                currency1: result.currency1,
              });
            }
          } catch (err) {
            logError(err, { module: 'PaymentsStore', func: 'onPlayerLoggedIn/yandex' });
          }
        }, i * 1200, purchases[i].purchaseData);
      }
    } else if (Config.PLATFORM === 'kongregate') {
      try {
        const result = await mutationClaimKongPurchases({
          playerId: action.player._id,
          kongAuthToken: kongregate.services.getGameAuthToken(),
          kongUserId: String(kongregate.services.getUserId()),
          platform: Config.PLATFORM,
        });
        if (result.currency1 != null) {
          CurrencyDispatcher.handleCurrencyAction({
            actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
            currency1: result.currency1,
          });
        }
        if (result.pdAmount > 0) {
          emit('KONG_PURCHASE_COMPLETE');
        }
      } catch (err) {
        logError(err, { module: 'PaymentsStore', func: 'onPlayerLoggedIn/kong' });
      }
    }
  } catch (err) {
    logError(err, {
      module: 'PaymentsStore',
      func: 'onPlayerLoggedIn',
    });
  }
}
